import React from "react";
import { connect } from "react-redux";
import { Popup } from "devextreme-react/popup";
import {
    DataGrid,
    Column,
    Scrolling,
    FilterRow,
    LoadPanel,
} from "devextreme-react/data-grid";

function SubstituteItemsPopup(props) {
    const { showPopup = {}, setShowPopup } = props;
    const visible = showPopup.visible === true;
    const data = Array.isArray(showPopup.data) ? showPopup.data : [];

    const handleHiding = () => {
        setShowPopup((prev) => ({ ...prev, visible: false }));
    };

    const amountFormat = { type: "fixedPoint", precision: 2 };

    return (
        <>
            {visible ? (
                <Popup
                    visible={true}
                    onHiding={handleHiding}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title={showPopup.title ?? "Substitute Items"}
                    container="#root"
                    width='80vw'
                    height='60vh'
                >
                    <DataGrid
                        dataSource={data}
                        keyExpr="Record"
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        hoverStateEnabled={true}
                        height="100%"
                        width="100%"
                        showColumnLines={true}
                        showRowLines={true}
                        paging={false}
                    >
                        <Scrolling mode="standard" />
                        <LoadPanel enabled={true} />
                        <Column dataField="ItemCode" caption="Item" dataType="string" width={130} />
                        <Column dataField="Description1" caption="Item Description - 1" dataType="string" width={160} />
                        <Column dataField="Description2" caption="Item Description - 2" dataType="string" width={160} />
                        <Column dataField="ClassCode" caption="Class Code" dataType="string" width={110} />
                        <Column dataField="SubClassCode" caption="Sub Class Code" dataType="string" width={120} />
                        <Column dataField="Available" caption="Available" dataType="number" alignment="right" format={amountFormat} width={110} />
                        <Column dataField="NetAvailable" caption="Net Available" dataType="number" alignment="right" format={amountFormat} width={110} />
                    </DataGrid>
                </Popup>
            ) : null}
        </>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(SubstituteItemsPopup);
